import { Permissions, security } from "Common/permissions";
import { connect } from "react-redux";
import { getInnerObjectsSelectedIds } from "../../documentDetails/redux/selectors";
import { getActiveDocumentId, getProjectId, getSourcesSelected } from "../redux/selectors";
import RowActionsPanel from "./rowActionsPanel";
const canAddToSummaryReports = security.isAllowed([
    Permissions.SummaryReportsEdit,
    Permissions.SummaryReportsView
]);
const mapStateToProps = (state, ownProps) => ({
    documentId: getActiveDocumentId(state),
    projectId: getProjectId(state),
    rowsSelectedCount: getInnerObjectsSelectedIds(state).length,
    nodeSourcesSelectedCount: getSourcesSelected(state).length,
    canAddToSummaryReports: canAddToSummaryReports &&
        (ownProps.canAddToSummaryReports !== undefined ? ownProps.canAddToSummaryReports : true)
});
export default connect(mapStateToProps)(RowActionsPanel);
